import { DrawCabinetInsideElement } from "$src/CGS/domain/dto/article/Cabinet/Inside/DrawCabinetInsideElement";
import { EInsideElement } from "$src/CGS/domain/dto/core/EInsideElement";
import { Length } from "$src/CGS/domain/dto/core/Length/Length";
import LengthValue from "$src/CGS/domain/dto/core/Length/LengthValue";
import { LengthValueMillimeter } from "$src/CGS/domain/dto/core/Length/LengthValueMillimeter";
import { Vector3 } from "three";

export class InsideElementMetadata {
    Type: EInsideElement = EInsideElement.PO;
    Anchor: Vector3 = new Vector3();
    Width?: Length;
    Height?: Length;
    Depth?: Length;
    BackPadding?: LengthValueMillimeter;
    FrontPadding?: LengthValueMillimeter;
    Context?: DrawCabinetInsideElement;
}

export class FrontFacePlacementMetadata {
    FaceIndex: number = 0;
    Offset: LengthValue | null;

    constructor(faceIndex: number, offset: LengthValue | null) {
        this.FaceIndex = faceIndex;
        this.Offset = offset;
    }
}
